import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import useStyles from "../ReportingCheckboxGroup.styles";

export const ReportingCheckbox = ({
  id,
  label,
  checked,
  update,
}: {
  id: string;
  label: string;
  checked?: boolean;
  update?: (key: string, value: boolean) => Promise<void>;
}) => {
  const classes = useStyles();

  const handleCheckboxChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    update && update(id, event.target.checked);
  };

  return (
    <Grid container className={classes.checkboxContainer}>
      <FormControlLabel
        label={
          <Grid container>
            <Typography variant="caption" fontSize={14}>
              {label}
            </Typography>
          </Grid>
        }
        control={
          <Checkbox
            className={classes.checkbox}
            checked={checked}
            onChange={handleCheckboxChange}
          />
        }
        className={classes.checkboxLabel}
      />
    </Grid>
  );
};
